
import * as sf from '%/s3functions';
import ax, { APPLY_DISCOUNT } from '%/axios';
import _ from 'lodash';
import { Parser } from 'expr-eval';

export const enableMobileDate = str => {
  if (typeof str !== 'string') {
    return str;
  }
  return str.replace(' ', 'T');
}
export const formatWebsite = str => {
  if (!str) return '';
  return str?.slice(0, 4) == 'http' ?
    str : 'http://' + str;
}

export const convertProductNameUrl = (str) =>
  encodeURIComponent(str?.toLowerCase().replace(' ', '-')) || 'product'
export const formatMDYShort = d => {

  let dat = enableMobileDate(d);
  if (!d) return '';

  const da = new Date(dat);
  const day = da.getDate();
  const mons = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
  return `${mons[da.getMonth()]} ${day}, ${da.getFullYear()}`
}
export const formatMDYLong = d => {

  let dat = enableMobileDate(d);
  if (!d) return '';

  const da = new Date(dat);
  const day = da.getDate();
  const mons = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  return `${mons[da.getMonth()]} ${day}, ${da.getFullYear()}`
}
export const formatDateTime = (d) => {
  let dat = enableMobileDate(d);
  if (!d) return '';

  const da = new Date(dat);
  const day = da.getDate();
  const mons = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  const t = da.toTimeString().slice(0, 8);

  return `${mons[da.getMonth()]} ${day}, ${da.getFullYear()} ${t}`
}
// Nov 24, 2022 @ 9:00 AM
export const formatMDYTime = (d) => {
  if (!d) return '';
  const dat = enableMobileDate(d);

  const da = new Date(dat);
  const day = da.getDate();
  const mons = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

  const t = da.toLocaleString().slice(-11);
  return `${mons[da.getMonth()]} ${day}, ${da.getFullYear()} @ ${t.slice(0, 5)} ${t.slice(-2)}`

}
export const determinePrice = (price_cents, divide = 100) => {
  if (!price_cents) {
    return '$0.00';
  }
  if (Number.isNaN(price_cents))
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(((Number(price_cents) / divide)));

  switch (navigator.language) {

    case 'en-US':

      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((price_cents / divide));
    default:
      return Number(price_cents / divide).toFixed(2);
  }
}
export const formatPhone = (ph = '') => {
  if (!ph) return '';
  if (ph.length === 10) {

    const a = ph.split('');
    a.splice(6, 0, '-')
    a.splice(3, 0, ') ')
    a.splice(0, 0, '(')
    return a.join('');
  }
  else if (ph.length >= 11 && ph.length < 14) {
    let phoneStr = ph.replace(/[\s|(|)|-|.]/ig, '')
      .replace('')
    const m = phoneStr.slice(0, phoneStr.length - 10);
    const a = phoneStr.slice(-10).split('');
    a.splice(6, 0, ' ');
    a.splice(3, 0, ' ');
    return `+${m || ''} ${a.join('')}`;
  }
  return ph;
}

export const textRange = (page = 1, perPage = 10, length = 0) => {

  return `${(page - 1) * perPage + Math.min(1, length)} - ${length < perPage ? (page - 1) * perPage + length : perPage * page}`
}

export const getDefaultImage = () => {
  return "https://dss-assets.s3.amazonaws.com/images/DSS-3D-BW.webp"
}
export const addScriptTag = (src = 'https://static.opentok.com/v2/js/opentok.min.js', id = 'opentok-script') => {

  const check = document.getElementById(id)
  if (check) return;
  const script = document.createElement("script");

  script.src = src;
  script.id = id;
  script.async = true;

  document.body.appendChild(script);
  return true;

}
export const commaSeperateNumber = (str) => {
  const arr = str.split('.');

  if (arr[0].length < 4)
    return arr.join('.');

  let commaSep = '';

  let ctr = 0;
  for (let i = arr[0].length - 1; i >= 0; i--) {
    commaSep += arr[0][i];
    ctr++;
    if (!(ctr % 3) && arr[0][i - 1]) {
      commaSep += ','
    }
  }
  // commaSep = commaSep.split().reverse().join();
  return [commaSep.split('').reverse().join(''), arr[1]].join('.');
}
export const getNodeFileAndName = (node) => {
  if (!node?.value) return {};
  return { file: node.files[0], name: node.value };
}

const maxFileSizes = {
  'product_images': 8,
  'product_videos': 100
};

export const generateVideoThumbnail = (vidSrc) => {
  return new Promise((resolve) => {
    const canvas = document.createElement("canvas");
    const video = document.createElement("video");

    // this is important
    video.autoplay = true;
    video.muted = true;
    video.src = vidSrc;

    video.onloadeddata = () => {
      let ctx = canvas.getContext("2d");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      ctx.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
      video.pause();
      return resolve(canvas.toDataURL("image/png"));
    };
  });
};

export const uploadMultiFilesNode = async (node, type = 'product_images', id = 'DECA_1', drop = null) => {
  try {
    if (!node) return;
    const files = drop || Array.from(node.files);
    const paths = [];

    for (const each of files) {

      try {
        let uploadRes, d2Path;
        d2Path = `local/${type}/${id}/${sf.randStr(5)}_${new Date().getTime()}_${each.name}`
        uploadRes = await sf.sendServerFile(each,
          d2Path,
          undefined,
          maxFileSizes[type] || undefined,
        );
        if (uploadRes) {
          paths.push(d2Path);
        }
      } catch (er) {
        console.error(er);
      }
    }
    return paths;
  } catch (er) {
    return new Error(er.message);
  }
}

export const uploadFileNode = async (node, type = 'product_images', id = null) => {
  try {
    if (!node) return;
    const {
      file: d2,
      name: d2Name
    } = getNodeFileAndName(node)
    if (!d2) return;
    let d2Path, uploadRes;
    if (d2Name) {
      d2Path = `local/${type}/${id ? (id + '/') : ''}${new Date().getTime()}_${d2Name.slice(-5)}`
      uploadRes = await sf.sendServerFile(d2,
        d2Path,
        null,
      );
      return d2Path;
    }
  } catch (er) {
    return new Error(er.message);
  }
}
export const kebabCase = (string = '') => string
  .replace(/[^\w ]/g, '')
  .replace(/([a-z])([A-Z])/g, "$1-$2")
  .replace(/[\s_]+/g, '-')
  .toLowerCase();

export const formatMDYSlashDate = (d = '2024-07-25 05:37:25') => {
  let dat = enableMobileDate(d);

  const da = new Date(dat);
  return `${da.getMonth() + 1}/${da.getDate()}/${da.getFullYear() - 2000}`
}

export const verifyToken = async (token) => {
  try {
    const res = await ax(VERIFY_RECAPTCHA, { token });
    return res;
  } catch (er) {
    conso.trace(er);
    throw new Error();

  }
}

export const determineCategories = (products = []) => {

  const stg = [];

  for (let i = 0; i < products.length; i++) {
    const each = products[i];
    each?.categories.forEach((category) => {
      if (!stg.some(cat => cat.id == category.id))
        stg.push(category)
    })
    if (stg.length > 2) {
      break;
    }
  }
  return stg;

}
export const validatePhone = (str) => {
  if (!str) return false;
  return /^\+?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4,6}$/im.test(str.replaceAll(' ', ''));
}

export const calculateEquation = (str = '') => {
  // needs to parse *, /, +, - operands
  // BEDMAS

  // split at operand
  if (!str?.toString()?.includes('='))
    return str;

  try {
    const str2 = str.replaceAll('=', '');
    const parser = new Parser();
    let res = parser
      .parse(str2)
      .evaluate();
    return res;
  } catch (er) {
    console.error(er);
    return 0;
  }

  // 
}
export const jsonToArray = (json = {}) => {
  return Object.entries(json).reduce((acc, [key, obj = {}]) => {
    if (typeof obj === 'object') {
      Object.keys(obj).forEach(each => {
        if (json[key][each])
          acc.push({ name: key, description: each })
      })
    }

    return acc;
  }, [])

}


export function getMonday(d) {
  d = new Date(d);
  const day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return new Date(d.setDate(diff));
}

export const textWeekRange = (str = '', custom = {}) => {

  let from = getMonday(new Date());

  if (str == 'Today') {
    from = new Date();
    return `${formatMDYLong(from)}`
  }
  if (str == 'Yesterday') {
    from = new Date(new Date().getTime() - 1000 * 24 * 3600)
    return `${formatMDYLong(from)}`
  }
  if (str == 'Last 7 Days') {
    from = new Date(new Date().getTime() - 1000 * 24 * 3600 * 7)
    return `${formatMDYLong(from)} - ${formatMDYLong(new Date())}`
  }
  if (str == 'Last 30 Days') {
    from = new Date(new Date().getTime() - 1000 * 24 * 3600 * 30)
    return `${formatMDYLong(from)} - ${formatMDYLong(new Date())}`
  }
  if (str == 'Last 90 Days') {
    from = new Date(new Date().getTime() - 1000 * 24 * 3600 * 90)
    return `${formatMDYLong(from)} - ${formatMDYLong(new Date())}`
  }
  if (str == 'Year to Date') {
    from = new Date(new Date(`${new Date().getFullYear()}-01-01T00:00:00`))
    return `${formatMDYLong(from)} - ${formatMDYLong(new Date())}`
  }
  if (str == 'Month to Date') {
    from = new Date(new Date(new Date().setDate(1)) + 3600 * 6 * 1000);
    return `${formatMDYLong(from)} - ${formatMDYLong(new Date())}`
  }
  if (str == 'Week to Date') {
    // return default
  }
  if (str == 'Last Year') {

    const yr = new Date().getFullYear() - 1;
    from = new Date(`${yr}-01-01T00:00:00`)
    const to = new Date(`${yr}-12-31T00:00:00`);
    return `${formatMDYLong(from)} - ${formatMDYLong(to)}`
  }
  if (str == 'Last Month') {

    // first of last month
    from = new Date((new Date(new Date().setMonth(new Date().getMonth() - 1))).setDate(1));
    // last day of last month
    const to = new Date(new Date().setDate(1) - 86400000);

    return `${formatMDYLong(from)} - ${formatMDYLong(to)}`
  } if (str == 'Custom') {
    return `${formatMDYLong(custom.from)} - ${formatMDYLong(custom.to)}`
  }

  return `${formatMDYLong(from)} - ${formatMDYLong(new Date())}`
}


export const filterListByProperties = (list = [], properties = ['fname', 'lname'], qs = '') => {

  const reg = new RegExp(qs, 'ig');

  return list.filter(each =>
    properties.some(property => {
      if (property.indexOf('.') > -1) {
        const arr = property.split('.');
        let val = each;
        // enables property drilling e.g. user.company.name
        arr.forEach(attribute => val = val[attribute]);
        return reg.test(val);
      }
      return reg.test(each[property])
    }
    )
  )

}
export const determinePercentChange = (initial = 0, val = 0) => {
  if (!val || !initial)
    return { value: 0, negative: false }
  const relative = (val - initial) / initial * 100
  return { value: Math.abs(relative).toFixed(1), negative: relative < 0 }
}

// return date object from timestamp in file name
export const parseProductExportTime = (fileName = '') => {
  if (!fileName)
    return null;
  const arr = fileName.split('_');
  const str = arr[arr.length - 1]?.split('.')[0];
  if (!str)
    return null;

  const timestamp = str * 1000;
  return `${(new Date(timestamp)).toLocaleDateString()} ${(new Date(timestamp)).toLocaleTimeString()}`;
}

export const toTitleCase = (str) => {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}
const handlePickListPromo = (promoAmount = 0, pickList, promoType = 'percentage-per-item') => {
  const adjust = 0;
  lineItem.add_ons?.forEach(each => {
    if (each.type == 'Pick List') {

      if (/percentage/.test(promoType)) {
        // adjust += promoAmount / 100 * (each.quantity * ) 

      }
    }
  })
}
export const determinePromoCodeAmount = (subtotal, promoCodePreview = {}, items = [], closeoutId = 0, pickList = {}) => {
  const conditions = promoCodePreview?.conditions || null;
  const exclude_closeout = promoCodePreview?.exclude_closeout || null;
  if (!promoCodePreview?.id) return 0;

  if (/percentage/.test(promoCodePreview?.discount_type)) {
    let savingsAmount = 0;
    // check discount conditions

    items.forEach(item => {
      // if(item['add_ons']) {
      //   item.add_ons.forEach((add_on) => {
      //     if(add_on['type'] == 'Pick List') {
      //       const itemPrice = add_on['price'];
      //       $variant = add_on['product_variant_pick_id'];
      //       $parentProductId = add_on['product_pick_id'];
      //       if($variant) {
      //         // $parentProductId = ProductVariant::find($add_on['product_variant_pick_id'])->product->id;
      //       }
      //       // $savingsTotal = $this->determineDiscountProductEligibility($parentProductId, $savingsTotal, $discount, $item['quantity'], $itemPrice);
      //     }
      //   }) 
      // }
      if (exclude_closeout && item.product?.categories.some(category => category.id == closeoutId)) {
        return;
      }
      if (conditions?.category_ids?.length) {
        if (item.product?.categories?.some(category => conditions.category_ids.includes(category.id) || conditions.category_ids.includes(category.root_parent_id))) {
          savingsAmount += item.item_price_cents * item.quantity * promoCodePreview?.discount_amount / 100;
        }
      } else if (conditions?.product_ids?.length) {
        if (conditions.product_ids.includes(item.product.id)) {
          savingsAmount += item.item_price_cents * item.quantity * promoCodePreview?.discount_amount / 100;
        }
      }
      else {
        savingsAmount += item.item_price_cents * item.quantity * promoCodePreview?.discount_amount / 100
      }
    })

    return savingsAmount
  } else if (promoCodePreview?.discount_type) {

    let savingsCount = 0;
    if ('fixed-per-item' === promoCodePreview.discount_type) {
      savingsCount = items.reduce((acc, item) => {


        if (!conditions.product_ids?.length && !conditions.category_ids?.length) {
          // discount has no conditions
          return acc + item.quantity;
        }
        return (conditions.product_ids?.includes(item.product.id) ||
          item.product.categories?.some(category => conditions.category_ids?.includes(category.id) || conditions.category_ids?.includes(category.root_parent_id))
        ) ? acc + (item.quantity || 1) : acc
      }, 0)
    } else {
      savingsCount = 1;
    }
    // fixed discount
    return promoCodePreview.discount_amount * savingsCount
  }
  // return savings

  return 0;
}

export const calculateTotal = (
  subtotal,
  taxTotal,
  promoCodePreview,
  giftCertificatePreview = {},
  nonTaxableSubtotal,
  customerGroupAmount = 0,
  items = [],
  closeoutId,
  pickList = {}
) => {
  // console.log(subtotal, taxTotal, nonTaxableSubtotal);
  let calculatedTotal = (taxTotal ? subtotal + taxTotal : subtotal) + nonTaxableSubtotal
  // - customerGroupAmount
  // const conditions  = promoCodePreview.conditions || null;
  const savingsAmount = determinePromoCodeAmount(subtotal, promoCodePreview, items, closeoutId, pickList);
  if (/percentage/.test(promoCodePreview?.discount_type)) {

    calculatedTotal = Math.max(0, calculatedTotal -
      savingsAmount
    );
  } else if (promoCodePreview?.discount_type) {

    calculatedTotal = Math.max(0, calculatedTotal - savingsAmount)
  }
  if (calculatedTotal > (giftCertificatePreview?.balance_cents || 0)) {
    return calculatedTotal - (giftCertificatePreview?.balance_cents || 0);
  }
  return 0;
}

export const createProductCategoryHash = (arr = []) => {
  return arr?.reduce((acc, each) => {
    acc[each.product_id] ?
      acc[each.product_id] = acc[each.product_id].concat({ id: each.category.id, name: each.category.name })
      : acc[each.product_id] = [{ id: each.category.id, name: each.category.name }]
    return acc;
  }, {})


}

export const findMaxAvailability = (productList = []) => {
  let sku = '';
  const maxAvailability = productList.reduce((acc, each) => {

    const str = each.availability;
    if (!str) return acc;
    const res = str.match(/[0-9]/);
    const max = acc.match(/[0-9]/);
    if (res && res[0] > max) {
      acc = str;
      sku = each.sku
    }
    return acc;
  }, "0")
  return sku ? `SKU: ${sku}: ${maxAvailability}` : `No lead time`;
}

export const applyDiscountApi = async (total, items = [], nonTaxable, token, cb = () => { }) => {
  try {
    const res = await ax(APPLY_DISCOUNT, { total, items, nonTaxable, token });
    if (res) {
      const { discountDifference, newAmount } = res;
      if (discountDifference == 0) {
        cb({ discountDifference: 0, newAmount: 0 });
      } else {
        cb({ discountDifference, newAmount });
      }
    } else {
      cb({ discountDifference: 0, newAmount: 0 });
    }
  } catch (er) {
    console.error(er);
  }
  return {};
}


export const calculateNewTableSizes = (idx, delta, adjustSize = '') => {
  const container = document.querySelector('#variants').clientWidth;
  const tableWidth = container - 25;
  // const initial = [0.25, 0.25, 0.914, 0.5, 0.5, 0.25, 0.25].map(each => (each * tableWidth / 3));
  const initial = adjustSize.split('px').filter(each => each).map(each => Number(each));

  initial[idx] = Math.min(500, initial[idx] + delta);
  initial[idx + 1] = Math.max(15, initial[idx + 1] - delta);
  return initial.map(each => `${each}px`).join(' ');
}

export const plural = (number = 0, singular = 'order', plural = 'orders') => {
  if (number == 1)
    return singular;
  return plural;
}


export const determineInitialVariantTableSize = () => {
  const container = document.querySelector('#variants').clientWidth;
  const tableWidth = container - 25;
  const sizesArr = [0.25, 0.25, 0.914, 0.5, 0.5, 0.25, 0.25].map(each => `${(each * tableWidth / 3)}px`);
  return sizesArr.join(' ');
}

export const determineInitialDividerPositions = (size = 6) => {

  const stg = [];
  for (let i = 0; i < size; i++) {
    const element = document.querySelector(`#variant-column-divider-${i}`);
    const val = (element.getBoundingClientRect().left)
    stg.push(val);
  }

  return stg;
}

export const validateAddress = (data) => {
  if (!data.city) return false;
  if (!data.full_name) return false;
  if (!data.zip) return false;
  if (!data.state) return false;
  if (!data.address_1) return false;

  return true;
}

export const compareArray = (arr1, arr2) => {
  return JSON.stringify(arr1) == JSON.stringify(arr2);
}
// json2 base, json1 may have _attributes
export const compareJson = (json1, json2) => {
  const cpy = { ...json1 };
  Object.keys(cpy).forEach(key => {
    if (key[0] === '_') {
      delete cpy[key];
    } else if (key === 'options') {
      delete cpy[key];
    }
  })

  return _.isEqual(json2, cpy);
}

const arrayMoveMutate = (array, from, to) => {
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
};

export const arrayMove = (array, from, to) => {
  const cpy = array?.concat();
  arrayMoveMutate(cpy, from, to);
  return cpy;
};


// from chatgpt
export function generateProductVariants(rawAttributes = []) {

  // const attributes = rawAttributes.reduce((acc, each) =>  {
  //   acc[each?.name || 'undefined'] = each.values?.map(each => each?.description) || [];
  //   return acc;
  // }, {})

  const attributes = {
    color: ['Red', 'Blue'],
    size: ['S', 'M', 'L'],
    material: ['Cotton', 'Polyester']
  }
  // Extract the keys and values from the attributes object
  const keys = Object.keys(attributes);
  const values = Object.values(attributes);

  // Initialize the result with a single empty combination (start point)
  let result = [{}];

  // Iterate over each set of attribute values
  for (let i = 0; i < keys.length; i++) {
    const currentValues = values[i];

    // Generate new combinations by adding each value from currentValues to existing combinations
    result = result.flatMap(combination =>
      currentValues.map(value => ({
        ...combination,  // Copy the current combination
        [keys[i]]: value // Add the current attribute and its value
      }))
    );
  }

  return result;

}